var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitterinline = function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.034 3 5.406 7.171L3 16h1.225l4.761-5.105L12.834 16H17l-5.709-7.573L16.353 3H15.13l-4.385 4.7L7.202 3H3.034Zm1.801.893H6.75l8.45 11.211h-1.913L4.835 3.894Z",
    fill: "#fff"
  })));
};

export default SvgTwitterinline;